import { PAYLOAD_URL } from "~/constants/all";
import { logInfo } from "~/lib/logger";
import { handleError } from "~/lib/payload/errors";
import { restPublic } from "~/lib/payload/rest";
import type { ApiResponse } from "~/types";

export const getPublicFeatureFlags = async (): Promise<ApiResponse<any>> => {
  try {
    logInfo("payloadFeatureFlags", "Getting public feature flags", {
      function: "getPublicFeatureFlags",
    });

    const res = await restPublic(
      `${PAYLOAD_URL}/api/feature-flags`,
      {},
      { method: "GET" }
    );

    if (res.errors) {
      return handleError(
        res,
        "Getting public feature flags failed",
        "getPublicFeatureFlags"
      );
    }

    // Loop over array of docs and turn to object.
    // Make the role the key and the value the doc.
    const flags = res.docs.reduce((acc: any, flag: any) => {
      acc[flag.role] = flag?.features;
      return acc;
    }, {});

    return {
      success: true,
      data: flags,
    };
  } catch (error) {
    return handleError(
      error,
      "Getting public feature flags failed",
      "getPublicFeatureFlags"
    );
  }
};
